module.exports = __webpack_public_path__ + "media/images/creature-bg-817c2983687f9af45d9add3a8592b80c.png";